module.exports = __webpack_public_path__ + "static/media/VisibilityIcon.734c9cb7.svg";